module.exports = __webpack_public_path__ + "static/media/Comingsoon_movies_new.487f11ab.png";